import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';
import { MESSAGES } from 'src/modules/common/constants.ts';
import { ReactNode } from 'react';

export const RecommendedChip = ({ rank }: { rank: number}): ReactNode => {
    switch (rank) {
        case 1:
            return '';
        case 2:
            return (
                <div className="vss-device__recommendation">
                    <I18n messageId={MESSAGES.recommended}/>
                </div>
            );
        default:
            return '';
    }
};
